import(/* webpackMode: "eager", webpackExports: ["AIVoiceoverWrapper"] */ "/app/apps/sb-shell/app/(main)/(dark)/ai/voiceover/_components/AiVoiceoverWrapper.tsx");
